<template>
  <div>
    <v-modal-contents ref="modal_contents_agree">
      <template v-slot:title>

        <div class="terms_of_use__title mt-30 pl-3 ">
          <div class="h2_title">Пользовательское соглашение!</div>

        </div>

      </template>
      <template v-slot:content>
        <div class="terms_of_use mt-30 ">
          <p class="red">ТЕКСТ НАХОДИТСЯ В РАЗРАБОТКЕ</p>

          <div class="mt-30">
            <button class="px-30 btn_bordered "
                    @click="$refs.modal_contents_agree.modal_open()">
              Прочитал
            </button>

          </div>
        </div>
      </template>
    </v-modal-contents>

    <v-form ref="form" class="form_upload" v-model="valid" lazy-validation>

      <section class="contact">
        <div class="containerCustom">
          <div class="contact__inner">
            <div class="contact__header">
              <h2 class="contact__title">Оставьте заявку и наш менеджер вам перезвонит</h2>
            </div>
            <div class="contact__content">
              <form class="contact__form">
                <div class="contact__box">

                  <v-text-field
                      v-model="name"
                      :rules="nameRules"
                      required=""
                      solo
                      class="contact__input"
                      placeholder="Имя"
                  ></v-text-field>

                  <v-text-field
                      v-model="tel_input"
                      :rules="tel_inputRules"
                      required
                      solo
                      placeholder="Телефон"
                      oninput="this.value = this.value.replace(/[^\d]/g,'');"
                      class=" contact__input"
                  ></v-text-field>
                </div>


                <v-textarea
                    v-model="message"
                    :rules="messageRules"
                    name="message"
                    filled
                    auto-grow
                    counter
                    solo="false"
                    row-height="24"
                    class="contact__textaria"
                    placeholder="Комментарий"
                >
                </v-textarea>


                <div class="contact__box">


                  <v-checkbox
                      v-model="checkbox"
                      :rules="[(v) => !!v || 'Вы должны подтвердить прочтение соглашения!']"
                      required
                      color="red"
                  >

                    <template v-slot:label>
                      <div class="contact__label">
                              <span class="contact__text">
                                  <a href="#"
                                     @click="$refs.modal_contents_agree.modal_open('scroll_false')">соглашение</a> на обработку персональных данных
                              </span>
                      </div>
                    </template>
                  </v-checkbox>

                </div>


                <div class=" ">
                  <v-btn :disabled="!valid" class="px-30 btn_red contact__send" @click="sendForm">
                    <span>Оставить заявку</span>
                  </v-btn>

                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

    </v-form>

  </div>

</template>
<script>
import VModalContents from './modal_contents.vue';

export default {
  name: "ApplicationForm",
  components: {
    VModalContents: VModalContents,
  },
  delimiters: ["${", "}"], // Avoid Twig conflicts
  data() {
    return {
      valid: true,

      name: "",
      nameRules: [
        (v) => !!v || "Поле 'Имя' не может быть пустым",
        (v) => (v && v.length >= 3) || "Поле 'Имя' не можети быть меньше 3 символов",
      ],
      message: "",
      messageRules: [
        (v) => !!v || "Поле 'Комментарий' не может быть пустым",
        (v) => (v && v.length >= 20) || "Поле 'Комментарий' не можети быть меньше 20 символов",
      ],

      tel_input: "",
      tel_inputRules: [
        (v) => !!v || "Поле 'Телефон' обязательно для заполнения",
        (v) => /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/.test(v) || "Телефон заполнен неправильно",
      ],
      checkbox: false,
    };
  },


  methods: {
    sendForm() {
      if (!this.$refs.form.validate()) return false;
      var VueObject = this;
      // $.ajax({
      //   "type": "POST",
      //   "url": "/ajax/contacts_form.php",
      //   "data": {
      //     "ajaxPost": "Y",
      //     "name": VueObject.name,
      //     "phone": VueObject.tel_items[VueObject.defaultSelectedTel.sel_id]["kod"] + " " + VueObject.tel_input,
      //     "email": VueObject.email,
      //     "type": VueObject.type_appeal[VueObject.type_appeal_sel.sel_id]["name"],
      //     "city": VueObject.city,
      //   },
      //   "success": function (res) {
      //     $(".text_result").slideDown(300);
      //     $(".text_result").delay(3000).slideUp(300);
      //     setTimeout(function () {
      //       window.location.reload()
      //     }, 3000);
      //   },
      //   "error": function (xhr, ajaxOptions, thrownError) {
      //     console.log(xhr.status);
      //     console.log(thrownError);
      //   }
      // });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },

};
</script>


<style lang="scss">
@import "../../theme/_variable.scss";

.contact {
  & .v-textarea.v-text-field--enclosed .v-text-field__slot {
    overflow-y: auto;
    max-height: 200px;
  }

  & .v-text-field.v-text-field--solo .v-input__control {
    position: relative;
  }

  @media(max-width: 610px) {
    & .v-text-field.v-text-field--enclosed {
      margin-bottom: 20px;
    }
  }

  & .theme--light.v-btn.v-btn--has-bg {
    background-color: #fe5c51 !important;
    background: #fe5c51;
    border-radius: 12px;
    padding: 13px 0;
    width: 100%;
    height: auto;
    font-family: 'MuseoSansCyrl-700';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 100%;
    text-align: center;
    box-shadow: none;
    text-transform: none;
  }

  & .theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover {
    background: none;
  }

  & .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
    font-family: 'RobotoRegular';
    padding-right: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.01em;
    color: #121212;
  }

  .v-input__control textarea,
  .v-input__control input {
    &::-webkit-input-placeholder,
    &::placeholder {
      font-family: 'RobotoRegular';
      caret-color: auto;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0.01em;
      color: #121212;
    }
  }

  & .mdi-checkbox-marked::before,
  & .mdi-checkbox-blank-outline::before {
    content: "";
    display: inline-block;
    width: 22px;
    height: 22px;
    background: #fff;
    border: 2px solid #fc6464;
    border-radius: 5px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 80% 80%;
    cursor: pointer;
  }

  & .mdi-checkbox-marked::before {
    border-color: #FC6464;
    background-color: #FC6464;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e");
  }


  & .v-text-field__details {
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 1;
    margin-bottom: 0 !important;
    bottom: -20px;
    left: 0;
    padding: 0 !important;
  }

  & .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background: none;
    border: none !important;
    margin: 0;
  }
}

</style>
